import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TypeEnum } from '../../../../models/template/type.enum';
import { TemplateEditorComponent } from '../../base-template-editor/template-editor.component';

@Component({
    selector: 'app-email-template',
    imports: [TemplateEditorComponent],
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `
    <app-template-editor
      [templateType]="templateType"
      templateBasePath="/email-template/"
      [enableDragDrop]="true"
      [enableBlockToolbar]="true"
      [showResponsysButton]="true"
      [showSaveAsEmpty]="true"
      [subscribeToMedia]="true"
      [defaultBlocks]="defaultBlocks" />
  `
})
export class EmailTemplateComponent {
  protected readonly templateType = TypeEnum.EMAIL;

  protected readonly defaultBlocks: { name: string; variables: Record<string, string> }[] = [
    { name: 'subject', variables: { Subject: '' } },
    { name: 'preheader', variables: { Preheader: '' } },
  ];
}
